import { z } from 'zod';
import { TimestampMsSchema } from '../../time';
import { defineEndpoint } from '../endpoint';

export const getHealth = defineEndpoint({
  method: 'GET',
  path: '/health',
  access: 'none',
  response: z.object({
    status: z.literal('ok'),
    version: z.string(),
    serverTime: TimestampMsSchema,
    uptimeMs: z.number().int().nonnegative(),
  }),
});
